// Gerichte-Produktseite mit Brücke in die Mix-&-Match-Box.
// Legt Gerichte wie der Baukasten in den Warenkorb (gleiche Cart-Properties), damit Gratis-Versand und Mengenrabatt greifen.
// Ändert sich nur die Menge eines Gerichts, wird nur diese Position geändert (schnell); bei anderem Lieferplan
// wird die ganze Box neu geschrieben, damit alle Positionen denselben Lieferplan haben.
// Die Anzeige reagiert sofort, der Warenkorb wird im Hintergrund gespeichert (Klicks laufen nacheinander ab).
(() => {
  const root = document.querySelector('[data-mdp]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-mdp-config]')?.textContent || '{}');
  const $ = sel => root.querySelector(sel);
  const $$ = sel => Array.from(root.querySelectorAll(sel));

  const el = {
    qty: $('[data-mdp-qty]'), minus: $('[data-mdp-minus]'), plus: $('[data-mdp-plus]'),
    unit: $('[data-mdp-unit]'), full: $('[data-mdp-full]'), portion: $('[data-mdp-portion]'), pips: $('[data-mdp-pips]'), msg: $('[data-mdp-msg]'),
    inbox: $('[data-mdp-inbox]'), plan: $('[data-mdp-plan]'), freq: $('[data-mdp-freq]'),
    add: $('[data-mdp-add]'), addPrice: $('[data-mdp-add-price]'), addLabel: $('[data-mdp-add-label]'), checkout: $('[data-mdp-checkout]'), error: $('[data-mdp-error]'),
    marks: $('[data-mdp-marks]'), sticky: $('[data-mdp-sticky]'), stickyAdd: $('[data-mdp-sticky-add]'), stickyPrice: $('[data-mdp-sticky-price]'), stickyMsg: $('[data-mdp-sticky-msg]'),
    toast: $('[data-mdp-toast]'), toastTitle: $('[data-mdp-toast-title]'), toastMsg: $('[data-mdp-toast-msg]'),
  };

  const PRICE = Number(cfg.dish?.price) || 0;
  const SHIP = Number(cfg.shippingAt) || 10;
  const PORTIONS = Number(cfg.portions) || 0;
  const cleanTiers = list => list.map(([at, pct]) => ({ at: Number(at), pct: Number(pct) })).filter(t => t.at > 0 && t.pct > 0).sort((a, b) => a.at - b.at);
  const tiersFor = key => cleanTiers(cfg.tiers?.[key] || []);
  // BW-Stufen als Text „ab:%“, z. B. „1:5, 12:20, 18:25, 24:30“
  const BW = cfg.bw || {};
  const parseTiers = str => cleanTiers(String(str || '').split(',').map(x => x.split(':')));
  const BW_TIERS = { sub: parseTiers(BW.tiers?.sub), once: parseTiers(BW.tiers?.once) };
  let bwMode = !!BW.active;
  let TIERS = bwMode ? BW_TIERS : { sub: tiersFor('sub'), once: tiersFor('once') };
  let collectionId = cfg.collectionId;
  const VERSION = cfg.template ? `${cfg.trackVersion} · ${cfg.template}` : cfg.trackVersion;

  let qty = Math.max(1, Number(cfg.startQty) || 1);
  // Einzelprodukt (nicht in Mix & Match): normaler Kauf ohne Box, Stufen und Lieferplan
  const STANDALONE = !!cfg.standalone;
  const ADD_LABEL = root.querySelector('[data-mdp-add-label]')?.textContent.trim() || 'In deine Box legen';
  const STICKY_LABEL = el.stickyAdd?.firstElementChild?.textContent.trim() || 'In die Box';
  let sub = el.plan ? el.plan.checked : false;
  let boxCount = 0;      // Gerichte, die schon als Mix-&-Match-Box im Warenkorb liegen
  let dishInBox = 0;     // davon dieses Gericht
  // Mengenschalter = gewünschte Anzahl dieses Gerichts in der Box (nicht „noch dazu“)
  let cartSub = null;    // Lieferplan, wie er gerade im Warenkorb liegt
  let cartFreq = '';

  // Texte aus dem Theme-Editor; [platzhalter] werden ersetzt, leere Felder fallen auf den Standard zurück
  const TX = cfg.texts || {};
  const t = (key, def, vars = {}) => String(TX[key] || def).replace(/\[(\w+)\]/g, (m, k) => (k in vars ? vars[k] : m));
  const dishes = n => (n === 1 ? t('dish_one', 'Gericht') : t('dish_many', 'Gerichte'));
  const dishesDat = n => (n === 1 ? t('dish_one', 'Gericht') : t('dish_dat', 'Gerichten'));

  const euro = cents => `€${(cents / 100).toFixed(2).replace('.', ',')}`;
  const tiers = () => (sub ? TIERS.sub : TIERS.once);
  const pctAt = n => tiers().reduce((best, t) => (n >= t.at ? Math.max(best, t.pct) : best), 0);
  const unitAt = n => Math.ceil(PRICE * (1 - pctAt(n) / 100));
  const marks = () => {
    const ship = t('mark_ship', 'Gratis-Versand');
    const list = [{ at: SHIP, label: ship, short: ship }];
    tiers().forEach(tier => {
      if (tier.at > 1) list.push({ at: tier.at, label: t('mark_tier', '[pct] % Rabatt', { pct: tier.pct }), short: t('mark_tier_short', '−[pct] %', { pct: tier.pct }) });
    });
    return list.sort((a, b) => a.at - b.at);
  };
  let MAX = 0;

  function track(event, data = {}) {
    const params = { mm_version: cfg.trackVersion, mm_template: cfg.template || '', mm_collection_id: String(collectionId || ''), dish: cfg.dish?.title, plan: sub ? 'lieferplan' : 'einmalig', ...data };
    try { window.Shopify?.analytics?.publish?.(event, params); } catch (err) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ mm: null }); window.dataLayer.push({ event, mm: params }); } catch (err) {}
  }

  // ── Fortschritt ────────────────────────────────────────────
  const pipEls = [];
  function buildPips() {
    MAX = Math.max(SHIP, ...TIERS.sub.map(t => t.at), ...TIERS.once.map(t => t.at));
    if (!el.pips) return;
    el.pips.replaceChildren();
    pipEls.length = 0;
    const ats = new Set([SHIP, ...TIERS.sub.map(t => t.at), ...TIERS.once.map(t => t.at)].filter(a => a > 1));
    for (let i = 1; i <= MAX; i++) {
      const pip = document.createElement('span');
      if (ats.has(i)) pip.className = 'is-ms';
      el.pips.appendChild(pip);
      pipEls.push(pip);
    }
  }
  buildPips();

  // Early Access: Liegt schon eine Box aus der BW-Kollektion im Warenkorb, bleibt sie eine BW-Box
  // (sonst würde das Neuschreiben sie zur normalen Box machen und der BW-Rabatt im Checkout entfiele).
  function adoptBox(lines) {
    const bwId = String(BW.collectionId || '');
    if (!bwId || String(collectionId) === bwId) return;
    if (!lines.some(l => String(l.properties?._mm_collection_id || '') === bwId)) return;
    switchToBw();
  }
  function switchToBw() {
    const bwId = String(BW.collectionId || '');
    if (!bwId || String(collectionId) === bwId) return;
    collectionId = bwId;
    TIERS = BW_TIERS;
    bwMode = true;
    buildPips();
    $$('[data-mdp-set]').forEach(n => { n.hidden = n.dataset.mdpSet !== 'bw'; });
    if (BW.collectionUrl) $$('[data-mdp-collection-link]').forEach(a => { a.href = BW.collectionUrl; });
  }

  // Early Access per E-Mail-Link: Danielas Theme-Code setzt diesen Merker (Theme-Einstellungen „Early Black Week“)
  let earlyAccess = false;
  try { earlyAccess = sessionStorage.getItem('early_access_black_week') === 'true'; } catch (e) {}
  if (earlyAccess && BW.earlyAccess !== false && !STANDALONE) switchToBw();

  // Beschriftung unter dem Balken: Gratis-Versand und Rabattstufen wie im Baukasten
  function renderMarks(total) {
    if (!el.marks) return;
    el.marks.replaceChildren();
    const list = marks();
    list.forEach((m, i) => {
      const node = document.createElement('span');
      node.className = `MDP__Mark ${i === 0 ? 'is-start' : i === list.length - 1 ? 'is-end' : 'is-mid'}`;
      node.style.setProperty('--pos', `${((m.at - 0.5) / MAX) * 100}%`);
      node.classList.toggle('is-done', total >= m.at);
      node.textContent = m.short;
      el.marks.appendChild(node);
    });
  }

  const freqNow = () => (sub && el.freq ? el.freq.value : '');
  // Box geändert? Anzahl dieses Gerichts oder Lieferplan weicht vom Warenkorb ab
  const planChanged = () => boxCount > 0 && cartSub !== null && (sub !== cartSub || freqNow() !== cartFreq);
  const isDirty = () => dishInBox === 0 || qty !== dishInBox || planChanged();
  const minQty = () => (dishInBox > 0 ? 0 : 1);

  function renderSingle() {
    el.qty.textContent = qty;
    el.minus.disabled = qty <= 1;
    el.unit.textContent = euro(PRICE);
    el.full.hidden = true;
    if (el.portion) el.portion.textContent = PORTIONS > 1 ? t('portion', ' · [price] pro Portion', { price: euro(Math.ceil(PRICE / PORTIONS)) }) : '';
    el.addPrice.textContent = euro(PRICE * qty);
    if (el.stickyPrice) el.stickyPrice.textContent = euro(PRICE * qty);
    if (el.stickyMsg) el.stickyMsg.textContent = t('sticky_empty', '[qty]× · [unit] / Glas', { qty, unit: euro(PRICE) });
    $$('[data-mdp-quick]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.mdpQuick) === qty)));
  }

  function render() {
    if (STANDALONE) { renderSingle(); return; }
    const others = boxCount - dishInBox;
    const total = others + qty;
    const unit = unitAt(total);
    const dirty = isDirty();
    el.qty.textContent = qty;
    el.minus.disabled = qty <= minQty();
    el.unit.textContent = euro(unit);
    el.full.hidden = unit >= PRICE;
    if (el.portion) el.portion.textContent = PORTIONS > 1 ? t('portion', ' · [price] pro Portion', { price: euro(Math.ceil(unit / PORTIONS)) }) : '';
    // Button: hinzufügen → aktualisieren / herausnehmen → ✓ unverändert
    let label = ADD_LABEL, short = STICKY_LABEL, price = euro(unit * qty);
    if (dishInBox > 0) {
      if (!dirty) { label = t('btn_done', '✓ In deiner Box'); short = t('sticky_done', '✓ In der Box'); price = ''; }
      else if (qty === 0) { label = t('btn_remove', 'Aus der Box nehmen'); short = t('sticky_remove', 'Herausnehmen'); price = ''; }
      else { label = t('btn_update', 'Box aktualisieren'); short = t('sticky_update', 'Aktualisieren'); }
    }
    if (el.addLabel) el.addLabel.textContent = label;
    el.addPrice.textContent = price;
    el.add.classList.toggle('is-done', !dirty);
    el.add.setAttribute('aria-disabled', String(!dirty));
    if (el.stickyAdd) {
      el.stickyAdd.firstElementChild.textContent = short;
      el.stickyAdd.classList.toggle('is-done', !dirty);
    }
    if (el.stickyPrice) el.stickyPrice.textContent = price;
    if (el.stickyMsg) {
      el.stickyMsg.textContent = boxCount === 0 ? t('sticky_empty', '[qty]× · [unit] / Glas', { qty, unit: euro(unit) })
        : dirty ? t('sticky_change', 'Box: [from] → [to] [dishes]', { from: boxCount, to: total, dishes: dishes(total) })
        : t('sticky_same', 'In der Box: [n]× · [count] [dishes]', { n: dishInBox, count: boxCount, dishes: dishes(boxCount) });
    }
    renderMarks(total);
    // Kräftig grün = bleibt in der Box, hellgrün = kommt dazu, gestrichelt = wird herausgenommen
    const keep = Math.min(boxCount, total);
    pipEls.forEach((pip, i) => {
      pip.classList.toggle('is-on', i < keep);
      pip.classList.toggle('is-next', i >= keep && i < total);
      pip.classList.toggle('is-drop', i >= total && i < boxCount);
    });
    const goal = marks().find(m => m.at > total);
    const rest = goal
      ? t('rest_goal', 'noch [n] bis [goal]', { n: `<strong>${goal.at - total}</strong>`, goal: goal.label })
      : t('rest_best', 'Bestpreis: −[pct] % + Gratis-Versand', { pct: pctAt(total) }).replace(/^([^:]+):/, '<strong>$1</strong>:');
    el.msg.innerHTML = boxCount === 0
      ? (goal ? t('msg_empty', 'Mit [count] [dishes] in der Box: [rest]', { count: total, dishes: dishesDat(total), rest }) : rest)
      : total !== boxCount
        ? t('msg_change', '[from] → [to] [dishes]: [rest]', { from: boxCount, to: total, dishes: dishes(total), rest })
        : t('msg_same', '[count] [dishes] in der Box: [rest]', { count: total, dishes: dishes(total), rest });
    if (el.inbox) {
      el.inbox.hidden = boxCount === 0;
      el.inbox.textContent = dishInBox > 0
        ? t('inbox_dish', 'In deiner Box: [count] [dishes], davon [n]× [dish]', { count: boxCount, dishes: dishes(boxCount), n: dishInBox, dish: cfg.dish.title })
        : t('inbox', 'In deiner Box: [count] [dishes]', { count: boxCount, dishes: dishes(boxCount) });
    }
    $$('[data-mdp-quick]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.mdpQuick) === qty)));
    if (el.freq) el.freq.hidden = !sub;
    renderPresets();
  }

  // Stand nach dem Lesen/Schreiben des Warenkorbs übernehmen; Schalter steht dann auf der Anzahl in der Box
  function syncFrom(qtyMap) {
    boxCount = Object.values(qtyMap).reduce((a, q) => a + q, 0);
    dishInBox = qtyMap[cfg.dish.id] || 0;
    qty = dishInBox > 0 ? dishInBox : Math.max(1, qty);
    cartSub = boxCount > 0 ? sub : null;
    cartFreq = freqNow();
  }

  // ── Fertige Boxen ──────────────────────────────────────────
  const presets = $$('[data-mdp-preset]').map(card => {
    let items = {};
    try { items = JSON.parse(card.dataset.mdpPreset); } catch (err) {}
    const count = Object.values(items).reduce((a, q) => a + q, 0);
    return { card, items, count, title: card.dataset.mdpPresetTitle };
  });
  function renderPresets() {
    presets.forEach(p => {
      const factor = 1 - pctAt(p.count) / 100;
      let full = 0, total = 0;
      Object.entries(p.items).forEach(([id, q]) => {
        const price = Number(cfg.prices?.[id]) || PRICE;
        full += price * q;
        total += Math.ceil(price * factor) * q;
      });
      p.card.querySelector('[data-mdp-preset-total]').textContent = euro(total);
      const fullEl = p.card.querySelector('[data-mdp-preset-full]');
      fullEl.textContent = euro(full);
      fullEl.hidden = total >= full;
      p.card.querySelector('[data-mdp-preset-count]').textContent = `${p.count} ${dishes(p.count)}`;
    });
  }

  // ── Warenkorb ──────────────────────────────────────────────
  async function readBox() {
    const cart = await fetch('/cart.js').then(r => r.json());
    const lines = cart.items.filter(i => i.properties && i.properties._is_mm);
    adoptBox(lines);
    const qtyMap = {};
    lines.forEach(l => { qtyMap[l.variant_id] = (qtyMap[l.variant_id] || 0) + l.quantity; });
    return { cart, lines, qtyMap };
  }

  // Schreibt die ganze Box neu: erst hinzufügen, dann alte Positionen entfernen (wie der Baukasten)
  async function writeBox(qtyMap, boxLabel, oldLines) {
    const ts = Date.now();
    const plan = sub && el.freq ? parseInt(el.freq.value, 10) : null;
    const items = Object.entries(qtyMap).filter(([, q]) => q > 0).map(([id, q]) => {
      const item = { id: Number(id), quantity: q, properties: { _is_mm: true, _mm_timestamp: ts, _mm_box: boxLabel, _mm_version: VERSION } };
      if (collectionId) item.properties._mm_collection_id = String(collectionId);
      if (sub) item.properties._is_mm_subscription = true;
      if (plan) item.selling_plan = plan;
      return item;
    });
    if (items.length) {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const res = await addRes.json().catch(() => ({}));
      if (!addRes.ok) throw new Error(res.description || res.message || 'Unbekannter Fehler');
    }
    if (oldLines.length) {
      const updates = {};
      oldLines.forEach(l => { updates[l.key] = 0; });
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
    }
    const cart = await fetch('/cart.js').then(r => r.json());
    refreshCartDrawer(cart.item_count);
    return cart;
  }

  // Flying Cart im Hintergrund aktualisieren, ohne ihn zu öffnen (der Hinweis „Box weiter füllen“ bleibt im Vordergrund).
  // Gleicher Weg wie das Theme selbst: /cart?view=drawer laden und den Inhalt von .Cart austauschen.
  async function refreshCartDrawer(count) {
    document.querySelectorAll('.Header__CartCount').forEach(n => { n.textContent = count; n.style.display = count > 0 ? 'block' : 'none'; });
    document.querySelectorAll('.Header__CartDot').forEach(n => n.classList.toggle('is-visible', count > 0));
    try {
      const drawer = document.getElementById('sidebar-cart');
      const current = drawer?.querySelector('.Cart');
      if (!current) return;
      const html = await fetch(`${window.theme?.localeRootUrl || ''}/cart?view=drawer&timestamp=${Date.now()}`, { credentials: 'same-origin' }).then(r => r.text());
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const next = tmp.querySelector('.Cart');
      if (next) current.replaceWith(next);
      document.dispatchEvent(new CustomEvent('cart:refreshed'));
    } catch (err) {}
  }

  const labelAfterChange = (oldLines, fallback) => {
    const prev = oldLines[0]?.properties?._mm_box;
    if (!prev) return fallback;
    return prev.replace('· unverändert', '· geändert');
  };

  // Warenkorb-Aufgaben laufen nacheinander (schnelle Klicks gehen nicht verloren).
  // dim = Bereich abdunkeln, solange gespeichert wird (nur wenn die Anzeige nicht schon vorab aktualisiert ist)
  let queue = Promise.resolve();
  let pendingTasks = 0;
  function run(task, { dim = true } = {}) {
    pendingTasks += 1;
    if (dim) root.classList.add('is-busy');
    el.error.hidden = true;
    const job = queue.then(task).catch(async err => {
      console.error('[MDP]', err);
      el.error.textContent = t('error', 'Das hat leider nicht geklappt: [message] Bitte versuch es noch einmal.', { message: err.message });
      el.error.hidden = false;
      track('mm_error', { message: String(err.message || err).slice(0, 150), via: 'pdp' });
      // Anzeige wieder an den echten Warenkorb anpassen
      try { const { qtyMap } = await readBox(); syncFrom(qtyMap); render(); } catch (e) {}
    }).finally(() => {
      pendingTasks -= 1;
      if (pendingTasks === 0) root.classList.remove('is-busy');
    });
    queue = job;
    return job;
  }

  function showToast(title, count) {
    const goal = marks().find(m => m.at > count);
    el.toastTitle.textContent = title;
    el.toastMsg.textContent = goal
      ? t('toast_goal', '[count] [dishes] in deiner Box. Noch [n] bis [goal].', { count, dishes: dishes(count), n: goal.at - count, goal: goal.label })
      : t('toast_best', '[count] [dishes] in deiner Box. Bestpreis erreicht.', { count, dishes: dishes(count) });
    el.toast.hidden = false;
    root.classList.toggle('has-sticky', !!el.sticky && !el.sticky.hidden);
  }

  // Gleicher Lieferplan wie gewünscht? Dann reicht es, eine einzelne Position zu ändern.
  const planOf = l => l.selling_plan_allocation?.selling_plan?.id || null;
  const samePlan = lines => {
    const want = sub && el.freq ? Number(el.freq.value) : null;
    return lines.every(l => planOf(l) === want && String(l.properties?._mm_collection_id || '') === String(collectionId || ''));
  };
  const post = async (url, body) => {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Unbekannter Fehler');
    return data;
  };

  // Menge eines Gerichts in der Box setzen: schnell über eine Position, sonst ganze Box neu
  async function setDishQty(variantId, newQty, lines, qtyMap, label, cartCount) {
    const map = { ...qtyMap };
    if (newQty > 0) map[variantId] = newQty; else delete map[variantId];
    const count = Object.values(map).reduce((a, q) => a + q, 0);
    const own = lines.filter(l => l.variant_id === variantId);
    if (lines.length && samePlan(lines) && own.length <= 1) {
      if (own.length === 1) {
        const cart = await post('/cart/change.js', { id: own[0].key, quantity: newQty });
        refreshCartDrawer(cart.item_count);
        return { map, count };
      }
      if (newQty > 0) {
        const props = { ...lines[0].properties, _mm_box: label, _mm_version: VERSION };
        const item = { id: Number(variantId), quantity: newQty, properties: props };
        if (planOf(lines[0])) item.selling_plan = planOf(lines[0]);
        await post('/cart/add.js', { items: [item] });
        refreshCartDrawer(cartCount + newQty);
        return { map, count };
      }
    }
    await writeBox(map, label, lines);
    return { map, count };
  }

  // Nach dem Speichern: echten Stand übernehmen, eine inzwischen geänderte Menge am Schalter bleibt erhalten
  function reconcile(map) {
    const pending = dishInBox > 0 ? qty - dishInBox : 0;
    syncFrom(map);
    qty = Math.max(minQty(), qty + pending);
    render();
  }

  // Querverkauf: ein anderes Gericht +1 in die Box. Anzeige sofort, Speichern im Hintergrund.
  function addDish(variantId, amount, title, via) {
    boxCount += amount;
    if (Number(variantId) === Number(cfg.dish.id)) { dishInBox += amount; qty += amount; }
    if (cartSub === null) { cartSub = sub; cartFreq = freqNow(); }
    render();
    showToast(t('toast_added', '[dish] ist in deiner Box ✓', { dish: title }), boxCount);
    return run(async () => {
      const { lines, qtyMap, cart } = await readBox();
      const { map, count } = await setDishQty(Number(variantId), (qtyMap[variantId] || 0) + amount, lines, qtyMap, labelAfterChange(lines, `PDP · ${cfg.dish.title}`), cart.item_count);
      track('mm_pdp_add', { qty: amount, count, via, value: (unitAt(count) * amount) / 100, currency: 'EUR', added_dish: title, discount_pct: pctAt(count) });
      reconcile(map);
    }, { dim: false });
  }

  // Einzelprodukt: normal in den Warenkorb, danach öffnet sich der Flying Cart (wie bisher im Shop)
  function addSingle(via, thenCheckout) {
    const amount = qty;
    return run(async () => {
      await post('/cart/add.js', { items: [{ id: Number(cfg.dish.id), quantity: amount }] });
      track('mm_pdp_add', { qty: amount, via: `${via}_single`, value: (PRICE * amount) / 100, currency: 'EUR', added_dish: cfg.dish.title });
      if (thenCheckout) { window.location.href = '/checkout'; return; }
      document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: cfg.dish.id, quantity: amount } }));
    }, { dim: true });
  }

  // Dieses Gericht: Anzahl in der Box auf den Schalter-Wert setzen (auch weniger oder 0)
  function applyDish(via, thenCheckout) {
    if (STANDALONE) return addSingle(via, thenCheckout);
    if (!isDirty()) {
      if (thenCheckout) { track('mm_pdp_checkout', { count: boxCount, via }); queue.then(() => { window.location.href = '/checkout'; }); }
      return;
    }
    const target = qty;
    const before = dishInBox;
    if (!thenCheckout) {
      // Anzeige sofort auf den neuen Stand
      boxCount = boxCount - dishInBox + target;
      dishInBox = target;
      cartSub = boxCount > 0 ? sub : null;
      cartFreq = freqNow();
      qty = dishInBox > 0 ? dishInBox : 1;
      render();
      const delta = target - before;
      showToast(delta > 0 ? t('toast_added', '[dish] ist in deiner Box ✓', { dish: cfg.dish.title }) : target === 0 ? t('toast_removed', '[dish] aus der Box genommen', { dish: cfg.dish.title }) : t('toast_updated', 'Box aktualisiert ✓'), boxCount);
    }
    return run(async () => {
      const { lines, qtyMap, cart } = await readBox();
      const was = qtyMap[cfg.dish.id] || 0;
      const delta = target - was;
      const { map, count } = await setDishQty(Number(cfg.dish.id), target, lines, qtyMap, labelAfterChange(lines, `PDP · ${cfg.dish.title}`), cart.item_count);
      const data = { qty: delta, count, via, value: (unitAt(count) * Math.max(delta, 0)) / 100, currency: 'EUR', added_dish: cfg.dish.title, discount_pct: pctAt(count) };
      track(delta > 0 ? 'mm_pdp_add' : 'mm_pdp_update', data);
      if (thenCheckout && count > 0) { window.location.href = '/checkout'; return; }
      reconcile(map);
    }, { dim: !!thenCheckout });
  }

  // ── Bedienung ──────────────────────────────────────────────
  const totalNow = () => boxCount - dishInBox + qty;
  el.minus.addEventListener('click', () => { qty = Math.max(STANDALONE ? 1 : minQty(), qty - 1); render(); track('mm_pdp_qty', { qty, via: 'stepper', count: totalNow() }); });
  el.plus.addEventListener('click', () => { qty += 1; render(); track('mm_pdp_qty', { qty, via: 'stepper', count: totalNow() }); });
  $$('[data-mdp-quick]').forEach(b => b.addEventListener('click', () => { qty = Number(b.dataset.mdpQuick); render(); track('mm_pdp_qty', { qty, via: 'quick', count: totalNow() }); }));
  el.freq?.addEventListener('change', () => { render(); track('mm_frequency_change', { frequency: el.freq.selectedOptions?.[0]?.textContent.trim() || '', via: 'pdp' }); });
  el.plan?.addEventListener('change', () => { sub = el.plan.checked; render(); track('mm_plan_toggle', { enabled: sub, count: totalNow(), via: 'pdp' }); });
  el.add.addEventListener('click', () => applyDish('pdp', false));
  el.stickyAdd?.addEventListener('click', () => applyDish('pdp_sticky', false));
  el.checkout.addEventListener('click', () => applyDish('pdp_checkout', true));
  $$('[data-mdp-cross]').forEach(b => b.addEventListener('click', () => {
    b.textContent = t('cross_done', '✓ In der Box');
    b.classList.add('is-added');
    addDish(Number(b.dataset.mdpCross), 1, b.dataset.mdpCrossTitle, 'pdp_cross').then(() => {
      if (el.error.hidden) { b.textContent = t('cross_done', '✓ In der Box'); b.classList.add('is-added'); }
    });
  }));
  presets.forEach(p => p.card.querySelector('[data-mdp-preset-pick]').addEventListener('click', () => run(async () => {
    const { lines } = await readBox();
    if (lines.length && !window.confirm(t('confirm_replace', 'Deine aktuelle Box ([count] [dishes]) wird durch „[title]“ ersetzt.', { count: boxCount, dishes: dishes(boxCount), title: p.title }))) return;
    track('mm_box_pick', { box_title: p.title, box_size: p.count, replaced: lines.length > 0, via: 'pdp' });
    await writeBox({ ...p.items }, `${p.title} · PDP`, lines);
    syncFrom(Object.fromEntries(Object.entries(p.items).map(([id, q]) => [id, Number(q)])));
    render();
    showToast(t('toast_added', '[dish] ist in deiner Box ✓', { dish: p.title }), p.count);
  })));
  root.querySelector('[data-mdp-toast-close]')?.addEventListener('click', () => { el.toast.hidden = true; track('mm_pdp_toast_close', { count: boxCount }); });
  // Aufgeklappte Bereiche (Nährwerte, Zubereitung, Box-Erklärung, SEO-Text)
  document.addEventListener('toggle', e => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    if (!root.contains(d) && !d.classList.contains('MDP__Seo')) return;
    track('mm_pdp_section_open', { pdp_section: d.querySelector('summary')?.textContent.trim().slice(0, 60) || '' });
  }, true);
  root.querySelector('[data-mdp-toast-go]')?.addEventListener('click', () => track('mm_pdp_continue', { count: boxCount, via: 'toast' }));
  root.querySelector('[data-mdp-toast-checkout]')?.addEventListener('click', () => track('mm_pdp_checkout', { count: boxCount, via: 'toast' }));
  root.querySelector('[data-mdp-probier]')?.addEventListener('click', () => track('mm_pdp_probier', { via: 'pdp' }));
  root.querySelector('[data-mdp-mmhint]')?.addEventListener('click', () => track('mm_pdp_continue', { via: 'single_hint' }));

  // Galerie-Punkte
  const slides = $('[data-mdp-slides]');
  const dotsWrap = $('[data-mdp-dots]');
  if (slides && dotsWrap && slides.children.length > 1) {
    const count = slides.children.length;
    const go = i => slides.scrollTo({ left: Math.max(0, Math.min(count - 1, i)) * slides.clientWidth, behavior: 'smooth' });
    const current = () => Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1));
    const dots = Array.from(slides.children).map((_, n) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Bild ${n + 1} von ${count}`);
      dot.addEventListener('click', () => go(n));
      return dotsWrap.appendChild(dot);
    });
    const prev = $('[data-mdp-prev]'), next = $('[data-mdp-next]');
    prev?.addEventListener('click', () => go(current() - 1));
    next?.addEventListener('click', () => go(current() + 1));
    const seen = new Set([0]);
    const sync = () => {
      const i = current();
      dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
      if (prev) prev.hidden = i <= 0;
      if (next) next.hidden = i >= count - 1;
      if (!seen.has(i)) { seen.add(i); track('mm_pdp_gallery', { pdp_slide: i + 1, pdp_slides: dots.length }); }
    };
    slides.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  // Feste Leiste (Handy): sichtbar, solange der Kaufknopf nicht im Bild ist
  const mobileMq = window.matchMedia('(max-width: 999px)');
  let stickySeen = false;
  if (el.sticky) {
    let raf = 0;
    const sync = () => {
      raf = 0;
      const r = el.add.getBoundingClientRect();
      const addVisible = r.bottom > 0 && r.top < window.innerHeight;
      const wasHidden = el.sticky.hidden;
      el.sticky.hidden = !mobileMq.matches || addVisible;
      root.classList.toggle('has-sticky', !el.sticky.hidden);
      if (wasHidden && !el.sticky.hidden && !stickySeen) { stickySeen = true; track('mm_pdp_sticky_view', { count: boxCount }); }
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(sync); };
    window.addEventListener('scroll', () => { schedule(); setTimeout(sync, 120); }, { passive: true });
    window.addEventListener('resize', schedule);
    mobileMq.addEventListener('change', sync);
    sync();
  }

  // Desktop: Kaufbereich läuft mit; ist er höher als der Bildschirm, bleibt sein unteres Ende sichtbar
  const buy = root.querySelector('.MDP__Buy');
  const desktopMq = window.matchMedia('(min-width: 1000px)');
  const setStickyTop = () => {
    if (!buy) return;
    if (!desktopMq.matches) { buy.style.top = ''; return; }
    buy.style.top = `${Math.min(150, window.innerHeight - buy.offsetHeight - 16)}px`;
  };
  setStickyTop();
  window.addEventListener('resize', setStickyTop);
  if ('ResizeObserver' in window && buy) new ResizeObserver(setStickyTop).observe(buy);

  // Sterne springen zu den Bewertungen
  root.querySelector('[data-mdp-to-reviews]')?.addEventListener('click', e => {
    const reviews = document.querySelector('[id$="__product-reviews"]');
    track('mm_pdp_reviews', { via: 'stars' });
    if (!reviews) return;
    e.preventDefault();
    reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // SEO-Texte bleiben im HTML, werden auf dieser Vorlage aber eingeklappt
  const seo = document.querySelector('[id$="__product-seo-texte"] .Container');
  if (seo && !seo.closest('details')) {
    const details = document.createElement('details');
    details.className = 'MDP__Seo';
    const summary = document.createElement('summary');
    summary.textContent = t('seo_title', 'Mehr über [dish]', { dish: cfg.dish.title });
    details.appendChild(summary);
    while (seo.firstChild) details.appendChild(seo.firstChild);
    seo.appendChild(details);
  }

  // Welche Abschnitte werden erreicht (einmal pro Seitenaufruf)
  const reachTargets = [
    ['kaufbereich', el.add], ['fertige_boxen', $('.MDP__Boxes')], ['passt_dazu', $('.MDP__Cross')],
    ['naehrstoffe', $('.MDP__Nutri')], ['bewertungen', document.querySelector('[id$="__product-reviews"]')], ['faq', document.querySelector('[id$="__product-faq"]')],
  ].filter(([, node]) => node);
  const reached = new Set();
  const checkReach = () => {
    reachTargets.forEach(([name, node]) => {
      if (reached.has(name)) return;
      const r = node.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.8 && r.bottom > 0) { reached.add(name); track('mm_pdp_reach', { pdp_section: name }); }
    });
  };
  window.addEventListener('scroll', () => setTimeout(checkReach, 150), { passive: true });
  setTimeout(checkReach, 800);

  // Zutaten und Nährwerttabelle sauber aufbereiten (Daten bleiben unverändert in den Produkt-Metafeldern)
  root.querySelectorAll('.MDP__AccBody').forEach(body => {
    body.querySelectorAll('[style]').forEach(n => n.removeAttribute('style'));
    body.querySelectorAll('table').forEach(table => {
      const rows = Array.from(table.rows).map(tr => Array.from(tr.cells).map(td => td.innerHTML.split(/<br\s*\/?>/i).map(part => part.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim())));
      if (!rows.length) return;
      const out = document.createElement('table');
      out.className = 'MDP__NutTable';
      rows.forEach((cells, ri) => {
        const lines = Math.max(...cells.map(c => c.length));
        for (let li = 0; li < lines; li++) {
          const tr = document.createElement(ri === 0 ? 'thead' : 'tr');
          const row = ri === 0 ? document.createElement('tr') : tr;
          cells.forEach((c, ci) => {
            const cell = document.createElement(ri === 0 ? 'th' : 'td');
            const text = c[li] ?? '';
            // „409 kJ/97 kcal“ zweizeilig, damit die Tabelle auf dem Handy nicht zu breit wird
            if (ci > 0 && /kJ\s*\/\s*\d/.test(text)) {
              const [kj, kcal] = text.split('/');
              cell.append(kj.trim(), document.createElement('br'), kcal.trim());
            } else {
              cell.textContent = text;
            }
            if (ci > 0) cell.className = 'is-num';
            row.appendChild(cell);
          });
          if (ri > 0 && /^davon/i.test(cells[0][li] || '')) row.classList.add('is-sub');
          if (ri === 0) { tr.appendChild(row); out.appendChild(tr); } else { out.appendChild(tr); }
        }
      });
      const wrap = document.createElement('div');
      wrap.className = 'MDP__NutWrap';
      wrap.appendChild(out);
      table.replaceWith(wrap);
    });
    const first = body.querySelector('p');
    if (first && /^Zutaten/i.test(first.textContent.trim())) {
      first.classList.add('MDP__Ingredients');
      first.innerHTML = first.innerHTML
        .replace(/^\s*<strong>Zutaten<\/strong>/i, '')
        .replace(/^(\s|&nbsp;|:|<span>|<\/span>)+/i, '');
      const h = document.createElement('h3');
      h.className = 'MDP__SubH';
      h.textContent = 'Zutaten';
      first.before(h);
      const wrap = body.querySelector('.MDP__NutWrap');
      if (wrap) { const h2 = document.createElement('h3'); h2.className = 'MDP__SubH'; h2.textContent = 'Nährwerte'; wrap.before(h2); }
    }
    body.querySelectorAll('p').forEach(p => { if (/^\(?[A-Z]{2}-BIO-\d+/.test(p.textContent.trim()) || /^\*/.test(p.textContent.trim())) p.classList.add('MDP__Fine'); });
  });

  // Nährstoffwerte mit Komma („18,8 g“), auch nach dem Umschalten männlich/weiblich
  const nutri = $('.MDP__Nutri');
  const commaFix = () => nutri?.querySelectorAll('.SingleNutritional--Title span').forEach(s => {
    const fixed = s.textContent.replace(/(\d)\.(\d)/g, '$1,$2');
    if (fixed !== s.textContent) s.textContent = fixed;
  });
  if (nutri) {
    commaFix();
    nutri.addEventListener('click', () => setTimeout(commaFix, 50));
    if ('MutationObserver' in window) new MutationObserver(commaFix).observe(nutri, { subtree: true, characterData: true, childList: true });
  }

  // Nährstoff-Balken (männlich/weiblich) wie auf der bisherigen Produktseite und im Pop-up
  if (typeof window.initPorductBars === 'function') { try { window.initPorductBars(); } catch (err) {} }

  // Start: bestehende Box aus dem Warenkorb übernehmen (Anzahl und Lieferplan)
  if (STANDALONE) { render(); } else readBox().then(({ lines, qtyMap }) => {
    if (lines.length && el.plan) {
      const subLine = lines.find(l => l.selling_plan_allocation);
      sub = !!subLine;
      el.plan.checked = sub;
      if (subLine && el.freq) el.freq.value = String(subLine.selling_plan_allocation.selling_plan.id);
    }
    syncFrom(qtyMap);
    render();
  }).catch(() => render());
  render();
  track('mm_pdp_view', { count: 0, qty, via: cfg.fromVariant ? 'variant_link' : 'pdp' });
})();
